import { createSlice } from '@reduxjs/toolkit'

const initialState = null

const meetingIframeSlice = createSlice({
  name: 'meetingIframe',
  initialState,
  reducers: {
    openMeetingIframe: (state, action) => state || action.payload,
    closeMeetingIframe: () => initialState,
  },
})

export const { openMeetingIframe, closeMeetingIframe } = meetingIframeSlice.actions

export default meetingIframeSlice.reducer
